import classNames from 'classnames'

const Notice = (
	{
		type = 'error',
		icon = 'info',
		children,
		...props
	}
) => {
	return (
		<div
			className={classNames({
				'sui-notice': true,
				[`sui-notice-${type}`]: true
			})}
			{...props}
		>
			<div className="sui-notice-content">
				<div className="sui-notice-message">
					{icon &&
						<span
							className={classNames({
								'sui-notice-icon': true,
								'sui-md': true,
								[`sui-icon-${icon}`]: true
							})}
							aria-hidden="true"
						></span>}
					{children}
				</div>
			</div>
		</div>
	)
}

export default Notice
